import Text from './text';
import Title from './title';
import Paragraph from './paragraph';

export default { Text, Title, Paragraph };
